module.exports = __webpack_public_path__ + "img/29.b6d16a14.png";